<div class="frontpage-widget cover-image-mose-gray">
  <div class="whitebox gray">
    <div class="container">
      <p class="text-muted">RISIKOVURDERING <i class="fa fa-chevron-right"></i></p>
      <h2 i18n>Søg lokalitet</h2>
      <p i18n>Start med at finde lokaliteten du ønsker at risikovurdere</p>
    </div>
  </div>
</div>
<div class="container">
  <div class="row mt-4">

    <div class="col-sm-12 col-lg-12">
      <h4 class="search-call-to-attention vd-fade fast" [ngClass]="{'out': !initialSearch, 'in': initialSearch}">Start
        din søgning</h4>
      <div>
        <div style="float: right; margin-bottom: 1rem;">
          <button class="btn btn-secondary" routerLink="/riskassessment/search-calculation">Vis mine beregninger</button>
        </div>
        <div class="vd-main-search-bar no-searchresults" [ngClass]="{'no-searchresults': initialSearch}">
          <input type="text" id="searchInput" [(ngModel)]="searchText" (keyup)="onInputChanged()"
            [disabled]="isSearching"
            aria-describedby="searchinput" placeholder="Søg efter lokalitetsnavn eller nummer (f.eks. 671-00281)...">
          <div>
            <span [ngClass]="{'in': isSearching, 'out': !isSearching}" class="vd-fade" style="margin-top: 2px"><i class="fa fa-circle-o-notch fa-spin fa-lg mr-3"></i></span>
            <button class="btn btn-secondary" [disabled]="isSearching" (click)="onClickSearchButton()">SØG <i class="fa fa-search"></i></button>
          </div>
        </div>

        <div *ngIf="!initialSearch">
          <div class="btn-group mt-3">
            <!-- <div class=""><span class="text-muted">Filtre:</span></div> -->
            <div class="dropdown">
              <a class="btn btn-outline-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{statusFilter?statusFilter.text:"Vælg status"}}
              </a>

              <div class="dropdown-menu">
                <a *ngFor="let filter of statusFilters" class="dropdown-item"
                  (click)="statusFilter=filter;refreshSearch()">
                  <span class="fa-stack risk-indicator"
                    [ngClass]="{'risk-computed':(filter.status==riskAssessmentStatus.Risk && filter.calculationType != highestRiskCalculationType.Screening), 'risk-screening':(filter.status==riskAssessmentStatus.Risk && filter.calculationType == highestRiskCalculationType.Screening), 'no-risk-computed':(filter.status==riskAssessmentStatus.NoRisk && filter.calculationType != highestRiskCalculationType.Screening), 'no-risk-screening':(filter.status==riskAssessmentStatus.NoRisk && filter.calculationType == highestRiskCalculationType.Screening)}">
                    <span class="icon"></span>
                  </span>
                  {{filter.text}}
                </a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" (click)="statusFilter=null;refreshSearch()">Vis alle</a>
              </div>
            </div>

            <div class="dropdown ml-3">
              <a class="btn btn-outline-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{userFilterText}}
              </a>

              <div class="dropdown-menu">
                <a class="dropdown-item" *ngFor="let caseWorker of caseWorkers" (click)="filterUser(caseWorker)">
                  <i class="fa fa-user fa-lg"></i> {{caseWorker.name}}
                </a>
                <div class="dropdown-divider"></div>
                <!-- <a class="dropdown-item" (click)="filterUserScreening()"><i class="fa fa-cog fa-lg"></i> Automatisk screening</a> -->
                <a class="dropdown-item" (click)="filterCaseWorkerClear()"><i class="fa fa-users fa-lg"></i> Vis
                  alle</a>
              </div>
            </div>

            <div class="form-control text-input sub-input ml-3">
              <input [(ngModel)]="contaminantName" (ngModelChange)="filterContaminants($event);"
                [matAutocomplete]="contaminantAutoComplete" name="contaminant" type="text" class="text-input"
                placeholder="Vælg forureningsstof" required />
              <mat-autocomplete #contaminantAutoComplete="matAutocomplete" (optionSelected)="refreshSearch()" panelWidth="auto"
                autoActiveFirstOption>
                <mat-option *ngFor="let compound of filteredCompoundList" [value]="compound.name">
                  {{ compound.name }}
                </mat-option>
              </mat-autocomplete>
            </div>

            <div class="form-control text-input sub-input ml-3">
              <span class="mr-1">Faktor fra:</span>
              <input type="number" [(ngModel)]="minFactor" (focusout)="refreshSearch();">
            </div>

            <div class="form-control text-input sub-input ml-1">
              <span class="mr-1">Faktor til:</span>
              <input type="number" [(ngModel)]="maxFactor" (focusout)="refreshSearch();">
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <!--<div [ngClass]="{'in': isSearching, 'out': !isSearching}" class="col-sm-12 col-lg-12 text-center mt-5 vd-fade"
      style="position: absolute;left: 0;">
      <app-load-indicator style="width: 25px; height: 25px;"></app-load-indicator>
      <h3 class="vd-text-muted font-weight-light mb-0 mt-1" i18n>Søger efter lokaliteter...</h3>
      <p class="text-muted mt-1">Vent et øjeblik</p>

    </div>-->
    <div *ngIf="!isSearching && allSearchResults != null && (allSearchResults?.length < 1)"
      class="col-sm-12 col-lg-12 mb-5 mt-3 text-center">
      <img style="width:8rem" src="assets/undraw_no_data_qbuo.svg">
      <p class="text-muted mt-3" i18n>Der blev desværre ikke fundet nogen lokaliteter...</p>
    </div>

    <div [ngClass]="{'in': displaySearchResults, 'out': !displaySearchResults}"
      class="col-sm-12 col-lg-12 mb-5 vd-fade">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th (click)="setOrderBy(locationSearchOrder.LocationNumber)">Lokalitetsnr.</th>
            <th (click)="setOrderBy(locationSearchOrder.LocationName)">Navn</th>
            <th (click)="setOrderBy(locationSearchOrder.RiskAssesmentStatus)">Status</th>
            <th (click)="setOrderBy(locationSearchOrder.RiskassessmentFactor)" style="white-space: nowrap">
              Overskridelsesfaktor <span class="text-muted">(alvorligste)</span></th>
            <th (click)="setOrderBy(locationSearchOrder.PollutantName)">Forureningsstof</th>
            <th (click)="setOrderBy(locationSearchOrder.RiskassessmentConcentration)">Koncentration</th>
            <th>Sagsbehandler</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let location of allSearchResults"
            [routerLink]="['/riskassessment/location-details', location.id]">
            <td>{{location.number}}</td>
            <td>{{location.name}}</td>
            <td style="white-space: nowrap;">
              <span *ngIf="location.calculationType != highestRiskCalculationType.None">
                <span class="fa-stack risk-indicator"
                  [ngClass]="{'risk-computed':(location.riskAssessmentStatus==riskAssessmentStatus.Risk && location.calculationType != highestRiskCalculationType.Screening), 'risk-screening':(location.riskAssessmentStatus==riskAssessmentStatus.Risk && location.calculationType == highestRiskCalculationType.Screening), 'no-risk-computed':(location.riskAssessmentStatus==riskAssessmentStatus.NoRisk && location.calculationType != highestRiskCalculationType.Screening), 'no-risk-screening':(location.riskAssessmentStatus==riskAssessmentStatus.NoRisk && location.calculationType == highestRiskCalculationType.Screening)}">

                </span>
                <span [ngSwitch]="location.riskAssessmentStatus" style="vertical-align: text-bottom;">
                  <span *ngSwitchCase="riskAssessmentStatus.Risk"><b>Risiko</b></span>
                  <span *ngSwitchCase="riskAssessmentStatus.NoRisk">Ingen risiko</span>
                </span>
              </span>
            </td>
            <td>
              <span *ngIf="location.factor">
                <span [ngSwitch]="location.riskAssessmentStatus">
                  <span
                    *ngSwitchCase="riskAssessmentStatus.Risk"><b>{{getValidNumber(location.factor) | number:'1.0-1'}}</b></span>
                  <span
                    *ngSwitchCase="riskAssessmentStatus.NoRisk">{{getValidNumber(location.factor) | number:'1.0-1'}}</span>
                </span>
                <span *ngIf="isScreening(location)" class="text-muted"> (screeningsresultat)</span>
              </span>
            </td>
            <td>{{location.contaminant}}</td>
            <td><span *ngIf="location.concentration">{{getNumberWithSignificantDigits(location.concentration)}}
                µg/L</span></td>
            <td>
              <span *ngIf="isScreening(location)" class="text-muted">
                <i class="fa fa-cog"></i>
                <span *ngIf="location.caseWorker"> {{location.caseWorker?.name}} (Omdømt)</span>
                <span *ngIf="!location.caseWorker"> Automatisk screening</span>
              </span>

              <span *ngIf="!isScreening(location) && location.caseWorker">
                <i class="fa fa-user"></i> {{location.caseWorker?.name}}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="text-center" *ngIf="!isContinuing && hasMoreSearchResults">
        <a href="javascript:void(0)" (click)="getMoreResults()">Hent flere resultater</a>
      </div>
      <div class="text-center" *ngIf="isContinuing">
        <p class="text-muted"><i class="fa fa-spinner fa-spin"></i> Henter lokaliteter</p>
      </div>
    </div>
  </div>
</div>

<button id="toggleForceCreateLocationModalButton" data-toggle="modal" class="d-none" data-target="#forceCreateLocationModal"></button>
<div
  id="forceCreateLocationModal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  aria-labelledby="forceCreateLocationModal"
  aria-hidden="true">
  <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center" role="document" style="max-width: 30vw;">
            <div class="modal-content">
                <div class="modal-body">
                    <div>
                      <span class="font-weight-bold">
                        {{ dkJordLocationReference }}
                      </span>
                      <span>
                        Lokaliteten eksisterer ikke i GrundRisk - vil du oprette den?
                      </span>
                    </div>
                </div>
                <div class="modal-footer pb-4 px-5 pt-4">
                    <button type="button"
                      id="dismissGeusDataModalButton"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      i18n>
                    Nej
                    </button>
                    <button type="button"
                      class="btn btn-dark"
                      data-dismiss="modal"
                      (click)="forceCreateLocation(dkJordLocationReference)"
                      i18n>
                    Ja
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>